export const OPERATION_POLLING_DELAY = 1000;
export const NAVBAR_ICON_BUTTON_PADDING = 24;
export const CONTENT_MAX_WIDTH = 1024 - NAVBAR_ICON_BUTTON_PADDING;
export const REDUCED_CONTENT_MAX_WIDTH = 500;
export const DIALOG_DESKTOP_MAX_WIDTH = 500;
export const SSO_BUTTON_MAX_WIDTH = 375;
